export default {
  title: 'Website overdragen',
  buttons: {
    cancel: 'Annuleren',
    transfer: 'Overdragen',
  },
  fields: {
    target_franchise: {
      label: 'Doelfranchise',
      description: 'Selecteer de franchise waarnaar de website wordt overgedragen',
    },
    sync_companies: {
      label: 'Bedrijfskoppelingen',
      description: 'Koppel bedrijven van de doelfranchise aan storefrontbedrijven',
      franchise_company: 'Franchisebedrijf',
      storefront_company: 'Storefrontbedrijf',
      select_franchise_company: 'Selecteer franchisebedrijf',
      select_storefront_company: 'Selecteer storefrontbedrijf',
      franchise_company_required: 'Franchisebedrijf is verplicht',
      storefront_company_required: 'Storefrontbedrijf is verplicht',
    },
  },
  toasts: {
    failed_to_load_companies: 'Laden van bedrijven mislukt',
    no_companies_selected: 'Voeg minimaal één bedrijfskoppeling toe',
    failed_to_transfer: 'Overdragen van website mislukt',
    transfer_success: 'Website succesvol overgedragen',
    franchise_already_connected: 'Doelfranchise is al verbonden met een website',
  },
};
